export default __webpack_public_path__ + "static/main-0fd7af5e3339afe8b36d97344f17e234.png";